const { m } = require('minthril');

function Button() {
  return {
    view: ({ attrs, children }) => m('button.button', attrs, children)
  };
}

module.exports = { Button };
